import React, { useEffect, useRef, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import AutoAdjustText from '../../Common/AutoAdjustText/AutoAdjustText';
import { formatDateForLabelPDF, formatDilution } from '../../../utils/format.utils';
import api from '../../../middleware/api';
import downloadPDF from '../../../utils/pdf.utils';
const MultiplePDF = () => {

    const location = useLocation();
    const [labels, setLabels] = useState(location.state.labels || [])
    const customerNamesRefs = useRef(labels.map(() => React.createRef())); // Crée un tableau de refs
    const capsuleNamesRefs = useRef(labels.map(() => React.createRef())); // Crée un tableau de refs
    const handleUpdateLabel = (value, property, index) => {
        if (labels.length < index) return;

        const updatedLabels = [...labels]
        updatedLabels[index][property] = value
        setLabels(updatedLabels)
    }

    const generatePDF = async () => {
        const payload = generatePayload();
        const response = await api.post(`/pdf/multiple`, payload);
        // Check if the response is successful
        if (response.status === 200) {
            downloadPDF(response.data, `MULTIPLE LABELS`);
        }
    }

    const getFontSize = (ref) => {
        if (ref.current === null) return 0;
        let customerFontSize = parseInt(ref.current.clientHeight)
        customerFontSize = (Math.floor(customerFontSize / 2)).toString() + 'px';
        return customerFontSize

    }


    const generatePayload = () => {
        const payload = {
            labels: labels.map((label, index) => {
                return {
                    customer_name: label.customer_name,
                    capsule_name: label.capsule_name,
                    dilutions: label.dilutions,
                    customerNameSize: getFontSize(customerNamesRefs.current[index]),
                    capsuleNameSize: getFontSize(capsuleNamesRefs.current[index])
                }
            })
        }
        console.log(payload.labels)
        return payload
    }

    if (labels.length === 0) return <div>Veuillez selectioner des capsules</div>


    return (
        <>
            <div style={{ display: 'flex', flexDirection: 'row', columnGap: '1em', width: '90%', flexWrap: 'wrap', margin: 'auto' }}>
                {
                    labels.map((label, key) => {
                        return (
                            <div key={key} className='flex flex-col gap-y-4 animate-fadeIn'>

                                <div className='pdf-container'>
                                    <div className='pdf-infos'>
                                        <div ref={customerNamesRefs.current[key]} className='pdf-details text-center text-ellipsis overflow-x-hidden whitespace-nowrap overflow-clip'>
                                            <AutoAdjustText onTextChange={handleUpdateLabel} index={key} property={'customer_name'} editable={true} text={label.customer_name} minFontSize={8} maxFontSize={14} />
                                        </div>
                                        <div ref={capsuleNamesRefs.current[key]} className='pdf-details justify-center'>
                                            <AutoAdjustText onTextChange={handleUpdateLabel} index={key} property={'capsule_name'} editable={true} text={label.capsule_name} minFontSize={6} maxFontSize={12} />
                                        </div>
                                        <div className='pdf-details pdf-footer'>
                                            <p>{formatDateForLabelPDF(label.creation_date)}</p>
                                            <p>{formatDilution(label.dilutions)}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                    })
                }
            </div>
            <button onClick={generatePDF} className='btn btn-primary w-32 ml-auto mr-4' color='primary'>Télécharger</button>
        </>

    )
}

export default MultiplePDF
